import WithModal from "@components/HOC/withModals";
import MinerContextProvider from "@components/Pages/Machines/MinerRow/MinerContext";
import MinerIdField from "@components/Pages/Machines/MinerRow/MinerIdField/MinerIdField";
import MinerPlan from "@components/Pages/Machines/MinerRow/MinerPlan/MinerPlan";
import MinerChart from "@components/Pages/Machines/MinerRow/MinerRowMore/MinerChart";
import MinerDataFields from "@components/Pages/Machines/MinerRow/MinerRowMore/MinerDataFields/MinerDataFields";
import MinerRowMoreSettings from "@components/Pages/Machines/MinerRow/MinerRowMore/MinerRowMoreSettings/MinerRowMoreSettings";
import StartMining from "@components/Pages/Machines/StartMining/StartMining";
import Title from "@components/global/new/Title/Title";
import { MODALS_ENUM } from "@constants/Modals";
import cn from "classnames";
import { useIntl } from "react-intl";
import styles from "./MinerInfoModal.module.scss";
import { IMinerInfoModalProps } from "./MinerInfoModal.props";
import MinerErrors from "@components/Pages/Machines/MinerRow/MinerRowMore/MinerRowMoreSettings/MinerErrors/MinerErrors";
import { IAdminMinerTable } from "@services/getMinerInfo";
import useMinerRowMoreChartControl from "@components/Pages/Machines/MinerRow/MinerRowMore/MinerRowMoreChart.control";

function MinerInfoContent(): JSX.Element {

  const { formatMessage } = useIntl();
  const control = useMinerRowMoreChartControl();

  return (
    <>
      <div className={styles.wrapper}>
        <Title className={styles.title_wrapper}>
          {formatMessage({ id: "chart_state.miner_id" })}{" "}
          <MinerIdField
            minerId={control.miner.id}
            text={control.miner.miner_id}
            hideDataCopy
          />
        </Title>
        <div className={styles.more_data}>
          <div>
            <MinerErrors />
          </div>
          <div className={styles.additional_header}>
            <div className={cn(styles.switcherGroup)}>
              {control.isAdmin && (
                <StartMining
                  minerID={control.miner.id}
                  status={control.miner.status}
                  onChangeStatus={control.onChangeStatus}
                  minerName={control.miner.miner_id}
                />
              )}
            </div>
          </div>
          <div>
            <MinerDataFields />
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "250px 1fr",
              gap: "20px",
              alignItems: "start",
            }}
          >
            <div>{control.miner.plan && <MinerPlan />}</div>
            <div className={styles.chart_wrapper}>
              <Title className={styles.title}>
                {formatMessage({ id: "machines.more.hashrate.title" })}
              </Title>
              <MinerChart
                defaultSpeed={control.miner.speed_default}
                speedDropsPercent={control.miner.speed_drop}
                minerId={control.miner.id}
                poolHash={control.miner.hash}
                currentSpeed={control.miner.speed_current}
                currentAccepted={control.miner.accepted || 0}
                currentRejected={control.miner.rejected || 0}
                currentState={control.miner.status}
              />
            </div>
          </div>
          <MinerRowMoreSettings miner={control.miner} />
        </div>
      </div>
    </>
  );
}

function MinerInfoModal({ show, handleClose, ...props }: IMinerInfoModalProps) {
  // if (!props.miner) return null;
  const miner = props.miner as unknown as IAdminMinerTable;

  return (
    <MinerContextProvider miner={miner}>
      <MinerInfoContent />
    </MinerContextProvider>
  );
}

export default WithModal(MODALS_ENUM.MORE_INFO_MODAL, MinerInfoModal, {
  style: {
    width: "80vw",
    // maxHeight: "80vh",
    // overflowY: "scroll",
  },
});
